import { render } from "./Courses.vue?vue&type=template&id=3340b1fa"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__